import { render, staticRenderFns } from "./Salers.vue?vue&type=template&id=0d45bc08&"
import script from "./Salers.vue?vue&type=script&lang=js&"
export * from "./Salers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports